<template lang="pug">
  content-placeholder(:rows="placeholderRows")
</template>

<script>
import ContentPlaceholder from 'vue-content-placeholder'

export default {
  name: 'LoadingPlaceholder',

  components: {
    ContentPlaceholder
  },

  data () {
    return {
      placeholderRows: [{
        height: '1.5rem',
        boxes: [[0, this.generateRandomWidthBetween(40, 100)]]
      }]
    }
  },

  methods: {
    generateRandomWidthBetween (min, max) {
      return (Math.floor(Math.random() * (max - min + 1)) + min) + '%'
    }
  }
}
</script>

<style>
.row {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// LoadingPlaceholder.vue?0250a37f